<ng-container [formGroup]="formData">
  <p-dropdown [id]="controlName" [name]="controlName" [formControlName]="controlName" [options]="optionList">
    <ng-template pTemplate="item" let-country>
      <div class="mu-dropdown-country-icon-content">
        <img src="assets/layout/images/flags/flag-{{ country.extra?.toLowerCase() }}.svg" alt="mu-flags" /> + {{ country.label }}
      </div>
    </ng-template>
    <ng-template let-country pTemplate="selectedItem"
      ><img src="assets/layout/images/flags/flag-{{ country.extra?.toLowerCase() }}.svg" alt="mu-flags" /> +{{ country.label }}</ng-template
    >
  </p-dropdown>
</ng-container>
